<template>
  <div id="CreateClaimSelectParts" class="bg-light pb-3">
    <div class="row">
      <p class="col pl-3 py-4">List the parts you received that you did not order below:</p>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <DnTable
          id="claimItemSelection"
          hover
          striped
          :items="Items"
          :fields="claimsPartsDataColumns"
          stacked="md"
          :no-provider-filtering="true"
          show-empty
          :no-local-sorting="true"
          class="blue mb-3"
        >
          <template #OemPartCode="{ row }">
            <b-form-input
              id="OemPartCode"
              v-model="row.item.OemPartCode"
              v-validate="{ required: true }"
              type="text"
              name="OemPartCode"
              @input="row.item.OemPartCode = row.item.OemPartCode.toUpperCase()"
            />
          </template>
          <template #Quantity="{ row }">
            <b-form-input
              id="itemQuantity"
              v-model="row.item.Quantity"
              v-validate="{ required: true, min: 1 }"
              type="number"
              name="itemQuantity"
              min="1"
              @blur="row.item.Quantity = Math.max(1, Math.abs(row.item.Quantity))"
            />
          </template>
          <template #RemoveItem="{  }">
            <DnFunctionButton
              button-id="removeRow"
              :callback-fn="RemovePart"
              :text="RemovePartText"
              extra-classes="pull-right"
              :include-event-in-params="true"
            />
          </template>
        </DnTable>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col add-part-button-wrapper">
        <DnFunctionButton
          button-id="addAPartToClaim"
          :callback-fn="AddPart"
          :text="AddPartText"
          extra-classes="pull-right"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters } from "vuex";
import { ClaimsService } from "@/services/ClaimsService";
import { PartsService } from "@/services/PartsService";
import DnFunctionButton from "@/components/Elements/DnFunctionButton";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
  components: {
    DnFunctionButton,
    DnTable,
  },

  props: {
    claimDto: {
      type: Object,
      default: () => ({}),
    },
    validationState: {
      addPartsTab: false,
      addPartsTabCurrentlyValidating: false,
    },
  },

  data: () => ({
    claimsPartsDataColumns: [
      { key: "RowNumber", label: "Row Number", sortable: false },
      { key: "OemPartCode", label: "Part Number", sortable: false },
      { key: "Quantity", label: "Quantity", sortable: false },
      { key: "RemoveItem", label: "Remove", sortable: false },
    ],
    Items: [{ RowNumber: 1, OemPartCode: "", Quantity: 1, Valid: false }],
    CurrentNumberOfItems: 1,
    AddPartText: "Add Part",
    RemovePartText: "X",
  }),

  computed: {
    ...mapGetters(["user", "activeAccountId", "tenantDetails", "McfCostCenterId"]),
  },

  created: function () {
    this.validationState.addPartsTab = false;
  },

  methods: {
    AddPart() {
      this.CurrentNumberOfItems += 1;
      let rowNum = this.CurrentNumberOfItems;
      this.Items.push({ RowNumber: rowNum, OemPartCode: "", Quantity: 1, Valid: false });
    },
    RemovePart(event) {
      this.CurrentNumberOfItems -= 1;
      let deleteButton = $(event.target);
      let row = deleteButton.closest("tr");
      let rowNum = parseInt(row.find(">td:first-child >div").text());

      this.Items = this.Items.filter(function (item, index, arr) {
        return item.RowNumber != rowNum;
      });

      this.Items.forEach(function (item, index) {
        item.RowNumber = index + 1;
      });
    },
    ValidateParts() {
      let self = this;
      self.validationState.addPartsTab = true;
      let promises = [];
      self.Items.forEach(function (item, index) {
        if (item.OemPartCode === "") {
          self.validationState.addPartsTab = false;
          let itemRow = $("#claimItemSelection").find("tr:eq(" + item.RowNumber + ") ");
          let OemPartCodeInput = itemRow.find("#OemPartCode");
          OemPartCodeInput.css("border", "2px solid red");
          OemPartCodeInput.attr("placeholder", "Please enter a part number");
        }
      });
      let partsCodes = [];
      self.Items.forEach(function (item, index) {
        partsCodes.push(item.OemPartCode);
      });
      return PartsService.GetMultiplePartDetails(
        self.McfCostCenterId,
        self.activeAccountId,
        self.user.UserId,
        partsCodes
      );
    },
  },
};
</script>

<style lang="scss">
.add-part-button-wrapper {
  text-align: center;

  > span {
    display: inline-block;
  }
}
</style>